var LABELS = require('../assets/labels/' + process.env.VUE_APP_ENV_MODE + '-labels')
export default {
    BACKEND_URL      : process.env.VUE_APP_BACKEND_URL + '?service=leseapp::',
    SHOP_URL         : process.env.VUE_APP_BACKEND_URL,
    SUBSCRIBE_URL    : process.env.VUE_APP_BACKEND_URL + '?digisubscribe',

    VERSION          : process.env.VUE_APP_VERSION,

    CACHE_PREFIX     : 'ms-leseapp2',
    CACHE_ADVERTISE  : 'advertise',
    CACHE_CONTENT    : 'content',
    CACHE_LOGIN      : 'login',
    CACHE_LOGIN      : 'login',
    CACHE_SETTINGS   : 'settings',
    CACHE_WEBBOOK    : 'webbook',
    
    SETTING_FONTSIZE     : 'fontSize',
    SETTING_VISITED      : 'visited',
    SETTING_FCMTOKEN     : 'fcmtoken',
    SETTING_SUBSCRIPTION : 'subscription',

    MAX_POSTS        : 20,

    LABEL_TOPICS     : LABELS.default.LABEL_TOPICS,
    LABEL_SUBTOPICS  : LABELS.default.LABEL_SUBTOPICS,
    LABEL_LISTVIEW   : LABELS.default.LABEL_LISTVIEW,
    LABEL_DETAILVIEW : LABELS.default.LABEL_DETAILVIEW,
    LABEL_MESSAGES   : LABELS.default.LABEL_MESSAGES,
    LABEL_WELCOME    : LABELS.default.LABEL_WELCOME,
    LABEL_IMPRESSUM  : LABELS.default.LABEL_IMPRESSUM,
    LABEL_STOB       : LABELS.default.LABEL_STOB,
    LABEL_PRIVACY    : LABELS.default.LABEL_PRIVACY,
    LABEL_REVOCATION : LABELS.default.LABEL_REVOCATION,
    LABEL_LOGIN      : LABELS.default.LABEL_LOGIN,
    LABEL_SUBSCRIBE  : LABELS.default.LABEL_SUBSCRIBE,
    LABEL_SETTINGS   : LABELS.default.LABEL_SETTINGS,
    LABEL_ERROR      : LABELS.default.LABEL_ERROR,
    LABEL_FILTER     : LABELS.default.LABEL_FILTER,
    LABEL_FILTERBTN  : LABELS.default.LABEL_FILTERBTN,
    LABEL_ALLTOPICS  : LABELS.default.LABEL_ALLTOPICS,
}